import { z } from "zod";

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

const isoDate = z.string().regex(ISO_DATE, "yyyy-mm-dd の形式で入力してください");

/**
 * 入力日数を日単位で測る。input[type=date] は UTC ベースで Date 化されるため
 * UTC で揃えてから差分を取ることで タイムゾーンずれによる ±1 日を防ぐ。
 */
function diffDays(fromIso: string, toIso: string): number {
  const from = Date.parse(`${fromIso}T00:00:00Z`);
  const to = Date.parse(`${toIso}T00:00:00Z`);
  return Math.round((to - from) / (1000 * 60 * 60 * 24));
}

/**
 * Step3 で人事担当が入力する項目だけを schema 化する。
 * 表 ①〜⑧ のうち、URL から決まる / 廃止 / 固定の項目は持たない。
 *  - ①企業名: URL の customerId から引くため schema に持たない
 *  - ②配付方法: WEB:メール配信 で固定 (mock では選択肢を出さない)
 *  - ④事前周知: 廃止
 *  - ⑤未受検者リスト / ⑥勧奨メール / ⑦延長: 運用側で固定
 */
export const periodInfoSchema = z
  .object({
    periodStart: isoDate,
    periodEnd: isoDate,
    notes: z
      .string()
      .max(500, "特記事項は 500 文字以内で入力してください")
      .optional()
      .or(z.literal("")),
  })
  .superRefine((data, ctx) => {
    const days = diffDays(data.periodStart, data.periodEnd);
    if (Number.isNaN(days)) return;

    if (days < 0) {
      ctx.addIssue({
        code: "custom",
        path: ["periodEnd"],
        message: "終了日は開始日以降にしてください",
      });
      return;
    }

    // 表 ③「実施期間は、開始日より最大 1 ヵ月の期間内」。
    // 開始日と終了日を含めた区間で 31 日まで許容 (日付の差で 30 日まで)。
    if (days > 30) {
      ctx.addIssue({
        code: "custom",
        path: ["periodEnd"],
        message: "実施期間は開始日から最大 1 ヵ月以内にしてください",
      });
    }
  });

export type PeriodInfoInput = z.infer<typeof periodInfoSchema>;
